/**
 * Slug helpers for SEO-friendly URLs and image filenames.
 * Matches the operations manual §06 convention: restaurant-city-dish.jpg.
 */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function reviewSlug(restaurantName: string, city: string | null): string {
  const parts = [restaurantName, city ?? ""].filter(Boolean);
  return slugify(parts.join(" "));
}

export function photoFilename(
  restaurantName: string,
  city: string | null,
  dish: string | null,
  extension: string,
): string {
  const base = slugify([restaurantName, city ?? "", dish ?? "plate"].join(" "));
  return `${base}.${extension.replace(/^\./, "")}`;
}
